export const reactQueryOptions = {
    refetchOnWindowFocus: false,
    retry: 1,
}